import { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useParams } from "react-router-dom";
import ErrorMessage from "../../../Components/ErrorMessage";
import MandatorySign from "../../../Components/MandatorySign";
import GeneralInput from "../GeneralInput";
import { GrClose } from "react-icons/gr";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const CONDITIONS = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Does not equal" },

    { value: "greater_than", label: "Greater than" },
    { value: "greater_than_or_equal", label: "Greater than or equal" },

    { value: "less_than", label: "Less than" },
    { value: "less_than_or_equal", label: "Less than or equal" },

    { value: "between", label: "Between" },
    { value: "not_between", label: "Not between" },

    { value: "contains", label: "Contains" },
    { value: "not_contains", label: "Does not contain" },

    { value: "starts_with", label: "Starts with" },
    { value: "ends_with", label: "Ends with" },

    { value: "is_empty", label: "Is empty" },
    { value: "is_not_empty", label: "Is not empty" },

    { value: "in", label: "Is in list" },
    { value: "not_in", label: "Is not in list" },
];

const InputIf = ({
    orderedNodes,
    executeNode,
    handleClose,
    handleSelect,
    selectedItem,
    selectedNode,
    executionHistory
}) => {
    const [value, setValue] = useState(null)
    const [selectedCondition, setSelectedCondition] = useState("equals")
    const [toValue, setToValue] = useState(null)

    const [errorMessage, setErrorMessage] = useState({
        message: "",
        display: false
    });

    const handleConfirm = () => {
        if (!value) {
            setErrorMessage({ message: "First value is required", display: true });
            return;
        }

        if (!selectedCondition) {
            setErrorMessage({ message: "A condition is required", display: true });
            return;
        }

        if (!toValue) {
            setErrorMessage({ message: "Second value is required", display: true });
            return;
        }

        handleSelect(selectedItem.value, selectedItem, {
            value: value,
            condition: selectedCondition,
            to_value: toValue,
        });
    };

    useEffect(() => {
        if (!selectedNode) return;

        const existing = selectedNode?.data?.params;

        if (existing) {
            setValue(existing.value ?? null);
            setSelectedCondition(existing.condition ?? "equals");
            setToValue(existing.to_value ?? null);
        }
    }, [selectedNode]);

    const isDynamicValue = value?.type === "dynamic";

    return (
        <>
            <div className="modal_main_cont">
                <GeneralInput
                    orderedNodes={orderedNodes}
                    selectedNode={selectedNode}
                    executeNode={executeNode}
                    executionHistory={executionHistory}
                    onSelectValue={(val) => {
                        setValue(val);
                    }}
                />

                <div className="label_input">
                    <label className="input_label">
                        Value <MandatorySign message="Value is required" />
                    </label>
                    {isDynamicValue ? (
                        <p
                            className="register_form_first fade-in pointer"
                            onClick={(e) => {
                                e.stopPropagation(); 
                                setValue(null);
                            }}
                        >
                            <span className="variable_content">
                                Output <strong>"{selectedNode?.type}"</strong>
                                <i className="remove_variable"><i className="fa-solid fa-x"></i></i>
                            </span>
                        </p>
                    ) : (
                        <input
                            className="register_form_first fade-in pointer"
                            value={value || ""}
                            onChange={(e) => setValue(e.target.value)}
                        />
                    )}
                </div>

                <div className="label_input">
                    <label className="input_label">
                        Condition <MandatorySign message="Condition is required" />
                    </label>
                    <Dropdown drop="down" autoClose="outside">
                        <Dropdown.Toggle as="div" className="register_form_first fade-in pointer">
                            {
                                CONDITIONS.find(c => c.value === selectedCondition)?.label || "Select condition"
                            }                        </Dropdown.Toggle>

                        <Dropdown.Menu className="custom_dropdown_menu">
                            <div className="scrollable_dropdown_cont">
                                {CONDITIONS.map((item) => (
                                    <div
                                        key={item.value}
                                        className={`settings_link ${item.value == selectedCondition && "settings_link_selected"}`}
                                        onClick={() => setSelectedCondition(item.value)}
                                    >
                                        {item.label}
                                    </div>
                                ))}
                            </div>

                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                <div className="label_input">
                    <label className="input_label">
                        To value <MandatorySign message="To value is required" />
                    </label>
                    <input
                        className="register_form_first fade-in pointer"
                        value={toValue || ""}
                        onChange={(e) => setToValue(e.target.value)}
                    />
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleConfirm}
                    >
                        Create IF condition
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </>
    );
};

export default InputIf;